import React from 'react';
import { InlineCta } from './InlineCta';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { steps } from '../data/offer';
export function HowItWorks() {
  return <section className="border-t border-espresso-line bg-espresso-2 px-5 py-14" data-id="element-148" data-mp="3pzjkca6yus1w">
      <SectionHeading dark eyebrow="Come funziona" title="Stampa. Insegna." accent="Fatto." data-id="element-149" data-mp="3tzjwfo6ler5s" />
      <ol className="relative mt-10 space-y-8" data-id="element-150" data-mp="lkjo8eqvcd8z">
        <div className="absolute bottom-8 left-7 top-8 w-px bg-espresso-line" aria-hidden="true" data-id="element-151" data-mp="lktfs6rkasgs" />
        {steps.map((step, i) => <Reveal key={step.title} delay={i * 0.05} data-id="element-152" data-mp="cry8z8mg4oow" data-mpi={i}>
            <li className="relative flex gap-5" data-id="element-153" data-mp="cr6mqoeqo3ba">
              <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-wood font-display text-2xl text-espresso ring-[6px] ring-espresso-2" data-id="element-154" data-mp="gtbhjqgxb5zi">
                {i + 1}
              </span>
              <div className="pt-1" data-id="element-155" data-mp="19ae4756hihxg">
                <h3 className="font-display text-2xl uppercase text-ivory" data-id="element-156" data-mp="19bfdb43xwucj">{step.title}</h3>
                <p className="mt-1 text-[15px] leading-relaxed text-sand" data-id="element-157" data-mp="2rmfvsudeswrb">{step.text}</p>
              </div>
            </li>
          </Reveal>)}
      </ol>
      <InlineCta dark label="Inizia stasera" data-id="element-158" data-mp="31bze9yx7moln" />
    </section>;
}